import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import {  Menu, MenuItem } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"
import InsureInformation from "./InsureInformation";
import RequestConcil from "./requestcouncil";
import RequestSmsReceiver from "./RequestSmsReceiver";
import SmsReceiverInformation from "./SmsReceiverInformation";
import {align} from "quill/ui/icons";
import RequestListSms from "./RequestListSms";
import ReactExport from "react-data-export";
import CurrentComments from "./currentComments";
const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styles = (theme) => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
    progress: {
        width: '100%',
        height: 10, // ارتفاع نوار درصد
    },
    progressContainer: {
        width: '100px', // عرض نوار درصد
    }
})
const Text = (props) => {
    return (
        <Container>
            <div  className="main-textt">
                <div className="text-title">{props.title}</div>
                <div className="text-detail">{props.detail}</div>
            </div>
        </Container>
    );
};

class Phonebookusers extends Component {
    cookies = new Cookies()
    temp333
    constructor(props) {
        super(props)
        this.state = {
            anchorEl: null, // برای مدیریت موقعیت منو
            currentRowId: null, // برای نگهداری ID ردیف جاری
            redirect: false,
            errstr: "",
            errstatus: false,
            okstatus: false,
            requestinfos: [],
            agentInfofilter: [],
            agentInfofilter2: [],
            rowsPerPage: 10,
            page: 0,
            id: "",
            idrequest: "",

            user_name: "",

            optionUserList: [],
            selectedUserList: "",


            insurer: "",
            full_name: "",
            typePolicy: "",
            beginDate: "",
            endDate: "",
            sms_date: "",
            vehicalName: "",
            plateNumber: "",
            policyholder: "",
            phone_number: "",
            nationalCode: "",
            message_content: "",
            excel_name: "",
            discountFinance: "",
            discountLife: "",
            discountDriver: "",
            no_major_damage: "",
            no_additional_damage: "",
            lastPolicyNumber: "",
            policyNumber: "",
            policyUniqueCode: "",
            engineNumber: "",
            chassisNo: "",
            vin: "",
            isEmployeeFilterActive: false,
            employee_id: "",
            auth_id: "",
            is_called: "",
            last_status: "",

            orderBy: "id",
            order: "desc",
            snackstr: "",
            showSnack: false,
            snackMode: "success",
            newAccidentMainCoverage: true,
            request_id: null,  // مقدار اولیه




        }

    }
    handleUserList = (selectedUserList) => {
        this.setState({ selectedUserList: selectedUserList }, () => {})
        this.getSmsReceiver(selectedUserList.value)

        console.log("maropele",selectedUserList.value)
    }

    gotoDetailRequest = (id,excel_name) => {

        if (this.state.request_id === id) {
            this.setState({ request_id: null });
        }else {
            this.setState({ request_id: id })

        }

        this.setState({ excel_name: excel_name })


    }
    handleClick = (event, rowId) => {
        event.stopPropagation(); // جلوگیری از انتشار رویداد کلیک
        this.setState({ anchorEl: event.currentTarget, currentRowId: rowId }); // نمایش منو و ذخیره ID ردیف
    };

    handleClose = () => {
        this.setState({ anchorEl: null, currentRowId: null }); // پنهان کردن منو
    };

    handleCallStatusUpdate2 = (smsStatus) => {
        const { currentRowId } = this.state; // استفاده از ID ردیف جاری
        console.log(`Updating status for row ID: ${currentRowId} with status: ${smsStatus}`);
        console.log("dalam",smsStatus)
        this.handleClose(); // منو را ببندید

        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.getSmsReceiver()


                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "change_is_called")
        fd.append("id", currentRowId)
        fd.append("call_status_id", smsStatus)

        xhttp.open("POST", `${constants.BASE_URL}/SmsReceiver`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)







        // اینجا کد بروزرسانی وضعیت را اضافه کنید
    };


    handleSelectRows = (row2) => {
        this.setState(
            {
                id: row2.id,
                accident_main_coverage_name: row2.accident_main_coverage_name,
                insurer: row2.insurer,
                full_name: row2.full_name,
                typePolicy: row2.typePolicy,
                beginDate: row2.beginDate,
                endDate: row2.endDate,
                sms_date: row2.sms_date,
                vehicalName: row2.vehicalName,
                plateNumber: row2.plateNumber,
                policyholder: row2.policyholder,
                phone_number: row2.phone_number,
                nationalCode: row2.nationalCode,
                message_content: row2.message_content,
                excel_name: row2.excel_name,
                discountFinance: row2.discountFinance,
                discountLife: row2.discountLife,
                discountDriver: row2.discountDriver,
                no_major_damage: row2.no_major_damage,
                no_additional_damage: row2.no_additional_damage,
                lastPolicyNumber: row2.lastPolicyNumber,
                policyNumber: row2.policyNumber,
                policyUniqueCode: row2.policyUniqueCode,
                engineNumber: row2.engineNumber,
                chassisNo: row2.chassisNo,
                vin: row2.vin,
                employee_id: row2.employee_id,
                auth_id: row2.auth_id,
                is_called: row2.is_called,
                last_status: row2.last_status,
                request_id: row2.request_id,
                newAccidentMainCoverage: false,
            },
            () => {}
        )
    }




    componentDidMount() {
        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.getoptionUsers()
                        // self.getSmsReceiver()
                        // self.getSmsReceiverStatus()
                    } else if (arr.result === "error") {
                        self.setState({ redirect: true })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "checkemployeelogin")

            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ redirect: true })
        }
    }

    getSmsReceiver(id) {
        console.log('bartas',id)
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_phonebookusers")
        fd.append("user_id", id)

        xhttp.open("POST", `${constants.BASE_URL}/SmsReceiver`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }


    handleCallStatusUpdate3 = (id) => {


        console.log("hey u ",id)
        window.open(`http://localhost:3000/thirdparty2?id=${id}`, "_blank");



        // اینجا کد بروزرسانی وضعیت را اضافه کنید
    };


    getSmsReceiverStatus() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log("sohmj",arr)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter2: arr.data }, () => {})
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_sms_status")

        xhttp.open("POST", `${constants.BASE_URL}/SmsReceiver`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }
    getoptionUsers = () => {

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)

                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({ value: arr.data[k].user_id, label: arr.data[k].user_name })
                    }
                    self.setState({ optionUserList: Company }, () => {})
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_users")
        xhttp.open("POST", `${constants.BASE_URL}/SmsReceiver`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }




    createSortHandler = (field) => {
        if (this.state.orderBy === field) {
            if (this.state.order === "asc") {
                this.setState({ order: "desc" })
            } else {
                this.setState({ order: "asc" })
            }
        } else {
            this.setState({ orderBy: field, order: "asc" })
        }
        var arraytemp = [],
            i,
            j,
            temp,
            a,
            b
        arraytemp = this.state.agentInfofilter
        for (i = 0; i < arraytemp.length; i++) {
            for (j = 0; j < arraytemp.length - 1; j++) {
                a = arraytemp[j]
                b = arraytemp[j + 1]
                if (a[field] < b[field] && this.state.order === "asc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                } else if (a[field] > b[field] && this.state.order === "desc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                }
            }
        }
    }


    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }

    render() {
        const { anchorEl } = this.state; // موقعیت منو
        const { classes } = this.props
        const {
            agentPermision,
            snackMode,
            optionUserList,
            selectedUserList,
            snackstr,
            showSnack,
            isEmployeeFilterActive,
            newAccidentMainCoverage,
            id,
            user_name,
            insurer,
            full_name,
            typePolicy,
            beginDate,
            endDate,
            vehicalName,
            plateNumber,
            policyholder,
            phone_number,
            nationalCode,
            message_content,
            discountFinance,
            discountLife,
            discountDriver,
            lastPolicyNumber,
            policyNumber,
            policyUniqueCode,
            engineNumber,
            is_called,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            agentInfofilter2,
            rowsPerPage,
            page,

        } = this.state

        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container maxWidth="lg">
                                <Paper className={classes.root}>


                                    <Grid item xs={12}>
                                        <div>
                                            <label className="on">لیست کارمندان</label>
                                            <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"لیست کارمندان"}
                                                value={selectedUserList}
                                                onChange={this.handleUserList}
                                                options={optionUserList}
                                            />
                                        </div>
                                    </Grid>
                                </Paper>
                            </Container>
                        </Grid>
                    </Grid>



                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container maxWidth="xl">
                                <Paper className={classes.root}>


                                    <ExcelFile
                                        element={
                                            <Button variant="outlined" color="primary">
                                                {" "}
                                                {"اکسل "}
                                            </Button>
                                        }
                                    >
                                        <ExcelSheet data={agentInfofilter} name="نمایندگان">
                                            <ExcelColumn label="آی دی" value="id" />
                                            <ExcelColumn label="شرکت بیمه" value="insurer" />
                                            <ExcelColumn label="نوع سیاست" value="typePolicy" />
                                            <ExcelColumn label="نام کارمند" value="full_name" />
                                            <ExcelColumn label="تاریخ شروع" value="beginDate" />
                                            <ExcelColumn label="تاریخ پایان" value="endDate" />
                                            <ExcelColumn label="تاریخ ارجاع" value="sms_date" />
                                            <ExcelColumn label="نام خودرو" value="vehicalName" />
                                            <ExcelColumn label="پلاک ماشین" value="plateNumber" />
                                            <ExcelColumn label="نام/نام خانوادگی" value="policyholder" />
                                            <ExcelColumn label="شماره موبایل" value="phone_number" />
                                            <ExcelColumn label="کد ملی" value="nationalCode" />
                                            <ExcelColumn label="تخفیف مالی" value="discountFinance" />
                                            <ExcelColumn label="تخفیف زندگی" value="discountLife" />
                                            <ExcelColumn label="تخفیف راننده" value="discountDriver" />
                                            <ExcelColumn label="عدم خسارت اصلی" value="no_major_damage" />
                                            <ExcelColumn label="عدم خسارت اضافی" value="no_additional_damage" />
                                            <ExcelColumn label="lastPolicyNumber" value="lastPolicyNumber" />
                                            <ExcelColumn label="policyNumber" value="policyNumber" />
                                            <ExcelColumn label="policyUniqueCode" value="policyUniqueCode" />
                                            <ExcelColumn label="شماره موتور" value="engineNumber" />
                                            <ExcelColumn label="شماره شاسی" value="chassisNo" />
                                            <ExcelColumn label="وین" value="vin" />
                                            <ExcelColumn label="نام اکسل" value="excel_name" />
                                            <ExcelColumn label="آخرین وضعیت" value="last_status" />

                                        </ExcelSheet>
                                    </ExcelFile>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        key={"id"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                        sortDirection={orderBy === "id" ? order : false}
                                                    >
                                                        {"آیدی "}
                                                        <TableSortLabel
                                                            active={orderBy === "id"}
                                                            direction={
                                                                orderBy === "id" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("id")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"insurer"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شرکت بیمه"}
                                                        <TableSortLabel
                                                            active={orderBy === "insurer"}
                                                            direction={
                                                                orderBy === "insurer" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("insurer")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"typePolicy"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نوع سیاست"}
                                                        <TableSortLabel
                                                            active={orderBy === "typePolicy"}
                                                            direction={
                                                                orderBy === "typePolicy" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("typePolicy")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"full_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام کارمند"}
                                                        <TableSortLabel
                                                            active={orderBy === "full_name"}
                                                            direction={
                                                                orderBy === "full_name" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("full_name")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"beginDate"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تاریخ شروع"}
                                                        <TableSortLabel
                                                            active={orderBy === "beginDate"}
                                                            direction={
                                                                orderBy === "beginDate" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("beginDate")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"endDate"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تاریخ پایان"}
                                                        <TableSortLabel
                                                            active={orderBy === "endDate"}
                                                            direction={
                                                                orderBy === "endDate" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("endDate")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"sms_date"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تاریخ ارجاع"}
                                                        <TableSortLabel
                                                            active={orderBy === "sms_date"}
                                                            direction={
                                                                orderBy === "sms_date" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("sms_date")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"vehicalName"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام خودرو"}
                                                        <TableSortLabel
                                                            active={orderBy === "vehicalName"}
                                                            direction={
                                                                orderBy === "vehicalName" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("vehicalName")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"plateNumber"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"پلاک ماشین"}
                                                        <TableSortLabel
                                                            active={orderBy === "plateNumber"}
                                                            direction={
                                                                orderBy === "plateNumber" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("plateNumber")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"policyholder"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام/نام خانوادگی"}
                                                        <TableSortLabel
                                                            active={orderBy === "policyholder"}
                                                            direction={
                                                                orderBy === "policyholder" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("policyholder")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"phone_number"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شماره موبایل"}
                                                        <TableSortLabel
                                                            active={orderBy === "phone_number"}
                                                            direction={
                                                                orderBy === "phone_number" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("phone_number")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"nationalCode"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"کد ملی"}
                                                        <TableSortLabel
                                                            active={orderBy === "nationalCode"}
                                                            direction={
                                                                orderBy === "nationalCode" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("nationalCode")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"discountFinance"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تخفیف مالی"}
                                                        <TableSortLabel
                                                            active={orderBy === "discountFinance"}
                                                            direction={
                                                                orderBy === "discountFinance" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("discountFinance")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"discountLife"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تخفیف زندگی"}
                                                        <TableSortLabel
                                                            active={orderBy === "discountLife"}
                                                            direction={
                                                                orderBy === "discountLife" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("discountLife")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"discountDriver"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تخفیف راننده"}
                                                        <TableSortLabel
                                                            active={orderBy === "discountDriver"}
                                                            direction={
                                                                orderBy === "discountDriver" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("discountDriver")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"no_major_damage"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"عدم خسارت اصلی"}
                                                        <TableSortLabel
                                                            active={orderBy === "no_major_damage"}
                                                            direction={
                                                                orderBy === "no_major_damage" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("no_major_damage")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"no_additional_damage"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"عدم خسارت اضافی"}
                                                        <TableSortLabel
                                                            active={orderBy === "no_additional_damage"}
                                                            direction={
                                                                orderBy === "no_additional_damage" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("no_additional_damage")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"lastPolicyNumber"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"lastPolicyNumber"}
                                                        <TableSortLabel
                                                            active={orderBy === "lastPolicyNumber"}
                                                            direction={
                                                                orderBy === "lastPolicyNumber" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("lastPolicyNumber")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"policyNumber"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"policyNumber"}
                                                        <TableSortLabel
                                                            active={orderBy === "policyNumber"}
                                                            direction={
                                                                orderBy === "policyNumber" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("policyNumber")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"policyUniqueCode"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"policyUniqueCode"}
                                                        <TableSortLabel
                                                            active={orderBy === "policyUniqueCode"}
                                                            direction={
                                                                orderBy === "policyUniqueCode" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("policyUniqueCode")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"engineNumber"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شماره موتور"}
                                                        <TableSortLabel
                                                            active={orderBy === "engineNumber"}
                                                            direction={
                                                                orderBy === "engineNumber" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("engineNumber")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"chassisNo"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شماره شاسی"}
                                                        <TableSortLabel
                                                            active={orderBy === "chassisNo"}
                                                            direction={
                                                                orderBy === "chassisNo" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("chassisNo")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"vin"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"وین"}
                                                        <TableSortLabel
                                                            active={orderBy === "vin"}
                                                            direction={
                                                                orderBy === "vin" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("vin")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"excel_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام اکسل"}
                                                        <TableSortLabel
                                                            active={orderBy === "excel_name"}
                                                            direction={
                                                                orderBy === "excel_name" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("excel_name")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>


                                                    <TableCell
                                                        key={"last_status"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"آخرین وضعیت"}
                                                        <br/>
                                                        <TableSortLabel
                                                            active={orderBy === "last_status"}
                                                            direction={
                                                                orderBy === "last_status" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("last_status")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>


                                                </TableRow>
                                            </TableHead>

                                            <TableBody>

                                                {agentInfofilter
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row) => {
                                                        if (isEmployeeFilterActive && row.employee_id !== row.auth_id) {
                                                            return null;
                                                        }
                                                        const color = row.percentage < 50 ? 'red' : row.percentage < 80 ? 'yellow' : 'green';
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.gotoDetailRequest(row.id,row.excel_name)
                                                                }}
                                                            >
                                                                <TableCell
                                                                    key={"id"}
                                                                    align={"center"}
                                                                >
                                                                    {row["id"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"insurer"}
                                                                    align={"center"}
                                                                >
                                                                    {row["insurer"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"typePolicy"}
                                                                    align={"center"}
                                                                >
                                                                    {row["typePolicy"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"full_name"}
                                                                    align={"center"}
                                                                >
                                                                    {row["full_name"]}
                                                                </TableCell>
                                                                {/*<TableCell*/}
                                                                {/*    key={"typePolicy"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    {row["typePolicy"]}*/}
                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"beginDate"}
                                                                    align={"center"}
                                                                >
                                                                    {row["beginDate"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"endDate"}
                                                                    align={"center"}
                                                                >
                                                                    {row["endDate"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"sms_date"}
                                                                    align={"center"}
                                                                >
                                                                    {row["sms_date"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"vehicalName"}
                                                                    align={"center"}
                                                                >
                                                                    {row["vehicalName"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"plateNumber"}
                                                                    align={"center"}
                                                                >
                                                                    {row["plateNumber"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"policyholder"}
                                                                    align={"center"}
                                                                >
                                                                    {row["policyholder"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"phone_number"}
                                                                    align={"center"}
                                                                >
                                                                    {row["phone_number"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"nationalCode"}
                                                                    align={"center"}
                                                                >
                                                                    {row["nationalCode"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"discountFinance"}
                                                                    align={"center"}
                                                                >
                                                                    {row["discountFinance"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"discountLife"}
                                                                    align={"center"}
                                                                >
                                                                    {row["discountLife"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"discountDriver"}
                                                                    align={"center"}
                                                                >
                                                                    {row["discountDriver"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"no_major_damage"}
                                                                    align={"center"}
                                                                >
                                                                    {row["no_major_damage"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"no_additional_damage"}
                                                                    align={"center"}
                                                                >
                                                                    {row["no_additional_damage"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"lastPolicyNumber"}
                                                                    align={"center"}
                                                                >
                                                                    {row["lastPolicyNumber"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"policyNumber"}
                                                                    align={"center"}
                                                                >
                                                                    {row["policyNumber"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"policyUniqueCode"}
                                                                    align={"center"}
                                                                >
                                                                    {row["policyUniqueCode"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"engineNumber"}
                                                                    align={"center"}
                                                                >
                                                                    {row["engineNumber"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"chassisNo"}
                                                                    align={"center"}
                                                                >
                                                                    {row["chassisNo"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"vin"}
                                                                    align={"center"}
                                                                >
                                                                    {row["vin"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"excel_name"}
                                                                    align={"center"}
                                                                >
                                                                    {row["excel_name"]}
                                                                </TableCell>



                                                                <TableCell
                                                                    key={"last_status"}
                                                                    align={"center"}
                                                                >
                                                                    {row["last_status"]}
                                                                    {/*<h5> ({row["full_name"]}) </h5>*/}
                                                                </TableCell>


                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={agentInfofilter.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </Container>

                            <Container component="main" maxWidth="lg">

                                <Container maxWidth="lg">
                                    <ul>
                                        {agentInfofilter
                                            .map((row) => {
                                                const color = this.state['request_id'];
                                                if (color === row.id) {
                                                    return (
                                                        <TableContainer component={Paper}>
                                                            <Table aria-label="vertical table">
                                                                <TableBody style={{ textAlign: "center" , direction: "rtl",}}>
                                                                    <TableRow>
                                                                        <TableCell align="center">insurer</TableCell>
                                                                        <TableCell align="center">{row.insurer}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">typePolicy</TableCell>
                                                                        <TableCell align="center">{row.typePolicy}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">beginDate</TableCell>
                                                                        <TableCell align="center">{row.beginDate}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">vehicalName</TableCell>
                                                                        <TableCell align="center">{row.vehicalName}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">plateNumber</TableCell>
                                                                        <TableCell align="center">{row.plateNumber}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">policyholder</TableCell>
                                                                        <TableCell align="center">{row.policyholder}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">phone_number</TableCell>
                                                                        <TableCell align="center">{row.phone_number}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">nationalCode</TableCell>
                                                                        <TableCell align="center">{row.nationalCode}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>

                                                                        <TableCell align="center">discountFinance</TableCell>
                                                                        <TableCell style={{ textAlign: "-webkit-center" }}
                                                                                   key={"discountFinance"}
                                                                        >
                                                                            <div className={classes.progressContainer}>
                                                                                <LinearProgress
                                                                                    className={classes.progress}
                                                                                    variant="determinate"
                                                                                    value={
                                                                                        // اصلاح عبارت منظم برای شناسایی اعداد منفی
                                                                                        row["discountFinance"].match(/\((-?\d+)%\)/)
                                                                                            ? Math.max(0, parseFloat(row["discountFinance"].match(/\((-?\d+)%\)/)[1]))
                                                                                            : 0 // اگر الگو پیدا نشد، مقدار ۰
                                                                                    }                                                                                />
                                                                            </div>
                                                                            {row["discountFinance"]}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">discountLife</TableCell>
                                                                        <TableCell style={{ textAlign: "-webkit-center" }}
                                                                                   key={"discountLife"}
                                                                        >
                                                                            <div className={classes.progressContainer}>
                                                                                <LinearProgress
                                                                                    className={classes.progress}
                                                                                    variant="determinate"
                                                                                    value={
                                                                                        // اصلاح عبارت منظم برای شناسایی اعداد منفی
                                                                                        row["discountLife"].match(/\((-?\d+)%\)/)
                                                                                            ? Math.max(0, parseFloat(row["discountLife"].match(/\((-?\d+)%\)/)[1]))
                                                                                            : 0 // اگر الگو پیدا نشد، مقدار ۰
                                                                                    }
                                                                                />
                                                                            </div>
                                                                            {row["discountLife"]}

                                                                        </TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">discountDriver</TableCell>

                                                                        <TableCell style={{ textAlign: "-webkit-center" , direction: "rtl",}}
                                                                                   key={"discountDriver"}
                                                                        >
                                                                            <div className={classes.progressContainer}>
                                                                                <LinearProgress
                                                                                    className={classes.progress}
                                                                                    variant="determinate"
                                                                                    value={
                                                                                        // اصلاح عبارت منظم برای شناسایی اعداد منفی
                                                                                        row["discountDriver"].match(/\((-?\d+)%\)/)
                                                                                            ? Math.max(0, parseFloat(row["discountDriver"].match(/\((-?\d+)%\)/)[1]))
                                                                                            : 0 // اگر الگو پیدا نشد، مقدار ۰
                                                                                    }
                                                                                />
                                                                            </div>
                                                                            {row["discountDriver"]}
                                                                        </TableCell>
                                                                    </TableRow>

                                                                    <TableRow>
                                                                        <TableCell align="center">lastPolicyNumber</TableCell>
                                                                        <TableCell align="center">{row.lastPolicyNumber}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">policyNumber</TableCell>
                                                                        <TableCell align="center">{row.policyNumber}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">policyUniqueCode</TableCell>
                                                                        <TableCell align="center">{row.policyUniqueCode}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">engineNumber</TableCell>
                                                                        <TableCell align="center">{row.engineNumber}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">chassisNo</TableCell>
                                                                        <TableCell align="center">{row.chassisNo}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center">vin</TableCell>
                                                                        <TableCell align="center">{row.vin}</TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>

                                                    )
                                                }

                                            })}
                                    </ul>




                                </Container>


                                <Container maxWidth="lg">


                                    {(this.state['excel_name'] === 'بدنه' || this.state['excel_name'] === 'ثالث') ? (
                                        <CurrentComments request_id={this.state['request_id']} />
                                    ) : (
                                        <RequestListSms request_id={this.state['request_id']} />
                                    )}
                                </Container>


                            </Container>
                        </Grid>
                    </Grid>


                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                </div>


            )
        }
    }
}

export default withStyles(styles)(Phonebookusers)
